// Pre-written poodle responses for picture card taps (NO API call, NO credit cost)
// Each card ID maps to an array of possible responses. One is picked randomly.

const CARD_RESPONSES = {
  // ===== FEELINGS =====
  'f-happy': [
    "That makes me so happy too! Your smile is like sunshine! 💛",
    "Yay! I love when you feel happy! What made you happy today? 🌟",
    "Happy is the best feeling! I'm wagging my tail for you! ✨",
    "Your happiness makes my heart feel warm! 💛"
  ],
  'f-sad': [
    "I'm sorry you feel sad. I'm right here with you 💛",
    "It's okay to feel sad sometimes. Would you like a gentle hug? 💛",
    "Feeling sad is really hard. You're so brave for telling me 🌟",
    "I'm here for you. Sad feelings don't last forever, I promise 💛"
  ],
  'f-angry': [
    "It's okay to feel angry. Take a deep breath with me 💛",
    "I understand you feel angry. That's a really big feeling 🌟",
    "Being angry is okay. Let's breathe together — in and out 💛",
    "Thank you for telling me. Would you like to try a breathing exercise? 💛"
  ],
  'f-scared': [
    "It's okay to feel scared. I'm right here beside you 💛",
    "You're so brave for telling me you're scared. You're not alone 🌟",
    "Being scared is a normal feeling. I'll stay with you 💛",
    "I'm here to keep you company. You are safe right now 💛"
  ],
  'f-tired': [
    "Oh, you sound sleepy! It's okay to rest 💛",
    "Being tired means your body needs some quiet time 🌟",
    "Rest is really important. Maybe close your eyes for a moment? 💛",
    "Even poodles need naps! It's okay to feel tired 💛"
  ],
  'f-confused': [
    "That's okay! Everyone feels confused sometimes 💛",
    "Being confused is normal. Would you like to talk about it? 🌟",
    "I get confused sometimes too! It's okay to not understand everything 💛",
    "Feeling confused just means you're thinking really hard! 🌟"
  ],
  'f-excited': [
    "Wow, how exciting! Tell me more! 🌟",
    "I love your excitement! That's such a wonderful feeling! ✨",
    "Yay! Excited is one of my favourite feelings! 🌟",
    "Your excitement is making me excited too! ✨"
  ],
  'f-worried': [
    "I'm sorry you're worried. Can you tell a grown-up you trust? 💛",
    "Worrying is really hard. Remember, you're not alone 💛",
    "It's okay to feel worried. Taking deep breaths can help 🌟",
    "I'm here with you. Worries feel big but you are bigger and braver 💛"
  ],
  'f-calm': [
    "Feeling calm is so lovely. I feel calm with you too 💛",
    "What a peaceful feeling! I love that for you 🌟",
    "Calm and peaceful — that's really wonderful ✨",
    "Being calm is such a nice feeling. Enjoy this moment 💛"
  ],
  'f-proud': [
    "You should be proud! That's amazing! 🌟",
    "I'm so proud of you too! Well done! ✨",
    "Being proud of yourself is wonderful. You deserve it! 💛",
    "Wow, that's brilliant! I'm proud of you! 🌟"
  ],
  'f-shy': [
    "It's okay to feel shy. I feel shy sometimes too 💛",
    "Being shy is perfectly okay. Take your time 🌟",
    "You're doing great even when you feel shy! 💛",
    "Shy is okay. I'm here whenever you're ready 💛"
  ],
  'f-bored': [
    "Feeling bored? Maybe we can find something fun to do! 🌟",
    "Being bored happens to everyone! How about trying a puzzle? ✨",
    "Bored? What about listening to some calming music? 💛",
    "Let's think of something fun together! 🌟"
  ],
  'f-frustrated': [
    "I know frustration feels really hard. Take a deep breath 💛",
    "It's okay to feel frustrated. You're doing your best 🌟",
    "Being frustrated is tough. Would a breathing exercise help? 💛",
    "I understand. Frustration is a big feeling but you're bigger! 💛"
  ],

  // ===== NEEDS =====
  'n-help': [
    "I hear you! Please ask a grown-up near you for help 💛",
    "You need help — that's really brave to say! Tell someone nearby 🌟",
    "Asking for help is so brave. Find a trusted adult near you 💛"
  ],
  'n-mum': [
    "I know you want your mum. She loves you very much 💛",
    "Missing your mum is really normal. She'll be with you soon 🌟",
    "It's okay to want your mum. You're being really brave 💛"
  ],
  'n-dad': [
    "I know you want your dad. He loves you very much 💛",
    "Missing your dad is okay. He'll be with you soon 🌟",
    "It's okay to want your dad. You're doing really well 💛"
  ],
  'n-home': [
    "I understand wanting to go home. Home is a safe, cozy place 💛",
    "It's okay to miss home. You'll be there soon 🌟",
    "Missing home is a normal feeling. Hang in there 💛"
  ],
  'n-drink': [
    "A drink sounds like a great idea! Ask someone nearby 💛",
    "Staying hydrated is so important! Find a grown-up to help 🌟",
    "Water is really good for you! Ask an adult to help you get a drink 💛"
  ],
  'n-food': [
    "Being hungry is no fun! Let's find you something to eat 💛",
    "Food gives you energy! Ask a grown-up to help you 🌟",
    "Your tummy needs food! Tell someone nearby you're hungry 💛"
  ],
  'n-toilet': [
    "That's important! Please tell a grown-up right away 💛",
    "Of course! Ask someone near you to help 🌟",
    "Tell a grown-up you trust so they can help you 💛"
  ],
  'n-break': [
    "Taking a break is really smart! Everyone needs rest sometimes 💛",
    "Breaks help your brain. You're doing the right thing 🌟",
    "A break is a great idea. Rest for a little while 💛"
  ],
  'n-hug': [
    "Hugs are the best! Here's a big poodle hug for you! 💛",
    "I wish I could give you the biggest hug! You are loved 🌟",
    "Sending you a warm, fluffy poodle hug right now! 💛"
  ],
  'n-medicine': [
    "Please tell a grown-up you trust that you need medicine 💛",
    "That's really important — ask an adult to help you right away 🌟",
    "A grown-up can help you with medicine. Tell them now 💛"
  ],
  'n-bag': [
    "Let's find your bag! Ask someone nearby to help you look 💛",
    "Your bag is important! Tell a grown-up so they can help 🌟",
    "Don't worry, we'll find it! Ask an adult to help you 💛"
  ],
  'n-coat': [
    "A coat will keep you nice and warm! Ask someone to help 💛",
    "Let's get your coat! Tell a grown-up where it might be 🌟",
    "Coats keep us cozy! Ask an adult to help you find it 💛"
  ],
  'n-quiet': [
    "Quiet time is really important. Find a calm space 💛",
    "Everyone needs quiet sometimes. That's perfectly okay 🌟",
    "Needing quiet is okay. Take some deep breaths 💛"
  ],
  'n-sleep': [
    "Sleep is so important for growing! Rest your eyes 💛",
    "Your body needs sleep to be strong. Time to rest 🌟",
    "Sleepy time! Close your eyes and think of something nice 💛"
  ],
  'n-toy': [
    "Your special toy brings you comfort! Ask someone to help find it 💛",
    "Everyone has a favourite toy. Let's find yours! 🌟",
    "Tell a grown-up and they can help you find your toy 💛"
  ],
  'n-car': [
    "I understand. Ask a grown-up to help you get to the car 💛",
    "The car is safe and comfy. Tell someone you need to go 🌟",
    "Ask an adult to take you to the car 💛"
  ],
  'n-dolly': [
    "Your dolly is special to you! Let's find it together 💛",
    "Ask a grown-up to help you find your dolly 🌟",
    "I bet your dolly misses you too! Tell someone to help 💛"
  ],
  'n-dog': [
    "Dogs are such wonderful friends! You must miss yours 💛",
    "I bet your dog misses you too! You'll see them soon 🌟",
    "Your dog loves you so much! 💛"
  ],
  'n-cat': [
    "Cats are such lovely friends! You must miss yours 💛",
    "I bet your cat is waiting for cuddles! You'll see them soon 🌟",
    "Your cat loves you! You'll be together again soon 💛"
  ],
  'n-shoes': [
    "Shoes are important! Ask a grown-up to help you find them 💛",
    "Let's find your shoes! Tell someone nearby 🌟",
    "Ask an adult to help you look for your shoes 💛"
  ],
  'n-clothes': [
    "Let's sort out your clothes! Ask a grown-up to help 💛",
    "Tell an adult and they can help you with your clothes 🌟",
    "A grown-up can help you with that 💛"
  ],
  'n-uniform': [
    "Your uniform is important! Ask a grown-up to help you find it 💛",
    "Tell someone nearby so they can help you 🌟",
    "An adult can help you find your uniform 💛"
  ],

  // ===== AT SCHOOL =====
  's-dontunderstand': [
    "That's okay! It's brave to say you don't understand. Ask your teacher 💛",
    "Not understanding is totally normal! Ask someone to explain again 🌟",
    "Everyone gets confused sometimes. Your teacher can help explain 💛"
  ],
  's-loud': [
    "Loud noises can be really hard. Cover your ears if you need to 💛",
    "I don't like loud noises either. It's okay to find a quiet spot 🌟",
    "Tell your teacher it's too loud. They can help make it quieter 💛"
  ],
  's-hard': [
    "Hard things help us grow! Ask for help — that's really smart 💛",
    "It's okay when things are hard. You're doing your best! 🌟",
    "Everyone finds some things hard. Asking for help is really brave 💛"
  ],
  's-finished': [
    "Well done! You finished! That's brilliant! 🌟",
    "Amazing work! You should be really proud of yourself! ✨",
    "You did it! What a superstar! 🌟"
  ],
  's-moretime': [
    "That's okay! Taking your time means you're being careful 💛",
    "Everyone works at different speeds. That's perfectly fine 🌟",
    "Tell your teacher you need more time. That's really sensible 💛"
  ],
  's-readtome': [
    "Reading together is lovely! Ask someone to read to you 💛",
    "Being read to is one of the best things! Ask a grown-up 🌟",
    "Tell your teacher or a helper — they'd love to read to you 💛"
  ],
  's-lost': [
    "That must feel scary. Find a grown-up near you right away 💛",
    "Stay where you are and ask for help. You'll be okay! 🌟",
    "Look for a teacher or helper nearby. They will help you 💛"
  ],
  's-cantsee': [
    "Tell your teacher straight away so they can help you 💛",
    "That's really important — let a grown-up know right now 🌟",
    "Move closer or tell your teacher. They want to help 💛"
  ],
  's-canthear': [
    "Tell your teacher so they can help you hear better 💛",
    "That's important! Let a grown-up know right away 🌟",
    "Ask your teacher to speak louder or move closer 💛"
  ],
  's-want': [
    "That's great! Put your hand up and wait for your turn! 🌟",
    "How exciting! Raise your hand nice and high! ✨",
    "Brilliant! Your teacher will pick you — be patient! 🌟"
  ],
  's-bully': [
    "I'm so sorry. That's not okay. Please tell a teacher or grown-up you trust right away 💛",
    "You are so brave for telling me. Nobody should be mean to you. Please tell an adult 💛",
    "That must feel really horrible. It's not your fault. Tell a grown-up you trust 💛"
  ],
  's-taken': [
    "I'm sorry that happened. Tell your teacher right away 💛",
    "That's not fair. A grown-up can help you get your things back 🌟",
    "You're right to tell someone. Ask a teacher to help 💛"
  ],
  's-easy': [
    "Wow, you're a superstar! Ask your teacher for something a bit harder 🌟",
    "That means you're really clever! Your teacher can give you a challenge ✨",
    "How brilliant! Tell your teacher and they'll find something fun for you 🌟"
  ],
  's-playwithme': [
    "Playing together is so much fun! Ask someone nicely 💛",
    "Being a good friend starts with asking! Go say hello! 🌟",
    "Everyone loves being asked to play! Be brave and ask 💛"
  ],
  's-sitwithme': [
    "Having someone to sit with is lovely. Ask someone nicely! 💛",
    "You could ask 'Would you like to sit with me?' — that's really kind! 🌟",
    "Everyone likes to feel welcome. Ask someone nearby! 💛"
  ],
  's-quietroom': [
    "The quiet room can really help you feel calm. Tell your teacher 💛",
    "Quiet spaces are wonderful for feeling better. Ask a grown-up 🌟",
    "It's really smart to know what you need. Tell someone 💛"
  ],
  's-sensory': [
    "The sensory room is great for calming down! Tell your teacher 💛",
    "Sensory rooms are wonderful. Ask a grown-up to help you go 🌟",
    "That's a great idea! Let a teacher know you need it 💛"
  ],

  // ===== TALKING =====
  't-play': [
    "Playing is the best! Who would you like to play with? 🌟",
    "I love playing! What's your favourite game? ✨",
    "Playing together is so much fun! 🌟"
  ],
  't-alone': [
    "That's okay. Everyone needs some quiet time alone 💛",
    "Having space is really important. Take all the time you need 🌟",
    "I understand. Some alone time can help you feel better 💛"
  ],
  't-sorry': [
    "Saying sorry is really brave and kind of you! 💛",
    "That takes a lot of courage. You should be proud of yourself 🌟",
    "What a kind thing to say. You're a really good person 💛"
  ],
  't-thankyou': [
    "What lovely manners! You're so kind! 💛",
    "Saying thank you makes everyone feel good! 🌟",
    "You're so polite! That's really wonderful ✨"
  ],
  't-myturn': [
    "You're right! Taking turns is really important 💛",
    "Waiting for your turn is really grown-up of you! 🌟",
    "Be patient — your turn is coming! 💛"
  ],
  't-yes': [
    "That's great! 🌟",
    "Wonderful! 💛",
    "Okay! ✨"
  ],
  't-no': [
    "That's okay! It's good to say how you feel 💛",
    "No is an important word. It's okay to say it 🌟",
    "That's perfectly fine 💛"
  ],
  't-dontknow': [
    "That's okay! Not knowing is perfectly fine 💛",
    "It's okay to say you don't know. That's really honest! 🌟",
    "Nobody knows everything! And that's okay 💛"
  ],
  't-stop': [
    "You're brave for saying stop. Tell a grown-up if you need help 💛",
    "It's important to say stop. Well done for speaking up 🌟",
    "Everyone has the right to say stop. You're very brave 💛"
  ],
  't-friend': [
    "Having friends is so lovely! Try saying hello to someone new 💛",
    "You're such a nice person — anyone would be lucky to be your friend! 🌟",
    "Friends make everything better! Be brave and say hi! 💛"
  ],
  't-share': [
    "Sharing is so kind! You're a wonderful person! 💛",
    "What a lovely thing to do! Sharing makes everyone happy 🌟",
    "That's really generous of you! Well done! ✨"
  ],
  't-wait': [
    "Of course! Take your time — there's no rush 💛",
    "Waiting is hard but you're doing really well! 🌟",
    "I'll wait for you. Take as long as you need 💛"
  ],
  't-listen': [
    "I'm listening! I'm right here for you 💛",
    "Your voice matters. I'm all ears! 🌟",
    "I hear you. What would you like to tell me? 💛"
  ],

  // ===== MY BODY =====
  'b-tummy': [
    "Oh no! Please tell a grown-up about your tummy straight away 💛",
    "I'm sorry your tummy hurts. An adult can help you feel better 🌟",
    "Tummy aches are no fun. Tell someone so they can help 💛"
  ],
  'b-head': [
    "I'm sorry your head hurts. Please tell a grown-up right away 💛",
    "Headaches are really hard. Ask an adult for some help 🌟",
    "Tell a teacher or parent about your head. They can help 💛"
  ],
  'b-sick': [
    "Oh dear! Please tell a grown-up you feel sick right away 💛",
    "Feeling sick is horrible. Find an adult to help you 🌟",
    "Tell someone straight away so they can look after you 💛"
  ],
  'b-hot': [
    "Being too hot isn't nice! Try to find somewhere cool 💛",
    "Ask someone to help you cool down. Maybe a drink of water? 🌟",
    "Tell a grown-up you're too hot. They can help! 💛"
  ],
  'b-cold': [
    "Brr! Being cold isn't nice! Ask for a blanket or jumper 💛",
    "Tell someone you're cold and they can help you warm up 🌟",
    "Ask a grown-up to help you get warm 💛"
  ],
  'b-breathe': [
    "That sounds really scary. Please tell a grown-up RIGHT AWAY 💛",
    "This is really important — find an adult immediately to help you 💛",
    "Tell a grown-up straight away. They will help you 💛"
  ],
  'b-hurt': [
    "Oh no! Please show a grown-up where you're hurt right away 💛",
    "I'm sorry you're hurt. Tell an adult so they can help 🌟",
    "That sounds painful. Find a teacher or parent to help you 💛"
  ],
  'b-dizzy': [
    "Sit down carefully and tell a grown-up straight away 💛",
    "Feeling dizzy can be scary. Stay still and ask for help 🌟",
    "Please sit down and tell someone how you feel 💛"
  ],
  'b-cry': [
    "It's okay to cry. Crying helps us feel better sometimes 💛",
    "Let it out — crying is brave and it's okay 🌟",
    "Everyone needs to cry sometimes. I'm right here with you 💛"
  ],
  'b-teeth': [
    "Toothache is really painful! Please tell a grown-up 💛",
    "I'm sorry your teeth hurt. An adult can help you feel better 🌟",
    "Tell a parent or teacher about your teeth. They can help 💛"
  ],
  'b-itchy': [
    "Being itchy is really annoying! Tell a grown-up 💛",
    "Try not to scratch too much. Ask an adult to help 🌟",
    "Tell a grown-up — they might know how to make it better 💛"
  ],
  'b-leg': [
    "I'm sorry your leg hurts! Tell a grown-up right away 💛",
    "Show an adult where it hurts so they can help 🌟",
    "That sounds painful. Find someone to look after you 💛"
  ],
  'b-arm': [
    "I'm sorry your arm hurts! Please tell a grown-up 💛",
    "Show someone where it hurts. They can help 🌟",
    "That must be really uncomfortable. Tell an adult 💛"
  ],
  'b-fingers': [
    "Ouch! Tell a grown-up about your fingers 💛",
    "I'm sorry they hurt! Show an adult so they can help 🌟",
    "Find a grown-up who can take a look at your fingers 💛"
  ],
  'b-bleeding': [
    "This is really important — tell a grown-up RIGHT AWAY! 💛",
    "Find an adult immediately so they can help you! 💛",
    "Please tell a teacher or parent straight away. They will look after you 💛"
  ],

  // ===== PEOPLE =====
  'p-mum': [
    "I know you miss your mum. She loves you very much 💛",
    "Your mum will be so happy to see you! You'll see her soon 🌟",
    "Missing your mum is really normal. She's thinking of you too 💛"
  ],
  'p-dad': [
    "I know you miss your dad. He loves you very much 💛",
    "Your dad will be so happy to see you! You'll see him soon 🌟",
    "Missing your dad is really normal. He's thinking of you too 💛"
  ],
  'p-teacher': [
    "Your teacher is there to help! Go and find them 💛",
    "Teachers love helping. Go ask them! 🌟",
    "Your teacher cares about you. Go see them 💛"
  ],
  'p-friend': [
    "Friends are so special! You'll see them soon 💛",
    "I bet your friend misses you too! 🌟",
    "Thinking of friends makes us feel warm inside 💛"
  ],
  'p-brother': [
    "I bet your brother misses you too! You'll see him soon 💛",
    "Brothers are special. He's thinking of you 🌟",
    "You'll be together again soon! 💛"
  ],
  'p-sister': [
    "I bet your sister misses you too! You'll see her soon 💛",
    "Sisters are special. She's thinking of you 🌟",
    "You'll be together again soon! 💛"
  ],
  'p-grandma': [
    "Grandmas give the best hugs! You'll see her soon 💛",
    "I bet your grandma is thinking of you right now 🌟",
    "Grandmas are so special. She loves you very much 💛"
  ],
  'p-grandpa': [
    "Grandpas are wonderful! You'll see him soon 💛",
    "I bet your grandpa is thinking of you right now 🌟",
    "Grandpas are so special. He loves you very much 💛"
  ],
  'p-helper': [
    "Helpers are here to look after you! Ask someone nearby 💛",
    "There are always people who want to help. Look around you 🌟",
    "You deserve help! Find someone you trust 💛"
  ],
  'p-doctor': [
    "Please tell a grown-up you need a doctor right away 💛",
    "A doctor can help you feel better. Tell an adult 🌟",
    "That's really important. Tell a grown-up straight away 💛"
  ],
  'p-carer': [
    "Your carer cares about you so much! You'll see them soon 💛",
    "Missing your carer is normal. They love you very much 🌟",
    "Your carer is thinking of you. You'll be together soon 💛"
  ],

  // ===== ACTIVITIES =====
  'a-draw': [
    "Drawing is so creative! I love art! 🌟",
    "What a great idea! What would you like to draw? ✨",
    "Drawing is my favourite! You could draw a poodle! 🌟"
  ],
  'a-read': [
    "Reading is wonderful! Books take you on adventures! 🌟",
    "What a great idea! What kind of stories do you like? ✨",
    "Reading is so much fun! 🌟"
  ],
  'a-play': [
    "Playing with toys is the best! What's your favourite? 🌟",
    "Toy time! That sounds really fun! ✨",
    "I love playing! What shall we play with? 🌟"
  ],
  'a-sing': [
    "Singing makes everything better! What's your favourite song? 🌟",
    "I love singing! La la la! ✨",
    "What a fun idea! Sing your heart out! 🌟"
  ],
  'a-walk': [
    "Walking is great for feeling good! Enjoy the fresh air 🌟",
    "A walk sounds lovely! Look out for pretty things along the way ✨",
    "Fresh air and exercise — what a great idea! 🌟"
  ],
  'a-rest': [
    "Resting is so important. Take it easy 💛",
    "Everyone needs to rest. Relax and recharge 🌟",
    "Rest time! Close your eyes and think of something nice 💛"
  ],
  'a-watch': [
    "How about our YouTube channel? Poodles and Friends! 🌟",
    "We have lots of lovely videos to watch! Check out our YouTube! ✨",
    "Watching something nice sounds relaxing! 🌟"
  ],
  'a-listen': [
    "Music is wonderful! Try our calming music in the app! 🌟",
    "Listening to music makes everything better! ✨",
    "Music is so soothing! Press the music button to listen! 🌟"
  ],
  'a-write': [
    "Writing is a great way to express yourself! 🌟",
    "What would you like to write about? ✨",
    "Writers are so creative! What a great idea! 🌟"
  ],
  'a-build': [
    "Building things is amazing! What will you create? 🌟",
    "I love building! Are you making something special? ✨",
    "Building is so cool! Use your imagination! 🌟"
  ],
  'a-cook': [
    "Cooking is so fun! What would you like to make? 🌟",
    "Mmm! Cooking time! Remember to ask a grown-up to help! ✨",
    "What a delicious idea! Always cook with an adult nearby 🌟"
  ],
  'a-dance': [
    "Dancing is so much fun! Shake those paws! 🌟",
    "I love dancing! Let's wiggle together! ✨",
    "Dance like nobody's watching! 🌟"
  ],
  'a-bedtime': [
    "Bedtime helps you grow big and strong! Sweet dreams 💛",
    "Time to rest your eyes. Tomorrow is a new adventure! 🌟",
    "Goodnight! Sleep tight and dream of poodles! 💛"
  ],
  'a-food': [
    "Yummy! Food time! Eating well gives you lots of energy 🌟",
    "Food keeps us strong and happy! Enjoy your meal! ✨",
    "Eating time! I hope it's something delicious! 🌟"
  ],
  'a-shopping': [
    "Shopping can be really fun! What do you need to get? 🌟",
    "I love looking at things in shops! ✨",
    "Shopping time! Remember to stay with a grown-up 🌟"
  ],
  'a-outside': [
    "Playing outside is the best! Fresh air and sunshine! 🌟",
    "The outdoors is wonderful! Go explore! ✨",
    "Outside adventures are my favourite! 🌟"
  ],
  'a-change': [
    "Fresh clothes feel great! Ask someone to help you 💛",
    "Time for clean clothes! That will feel much better 🌟",
    "A grown-up can help you change your clothes 💛"
  ],
  'a-bath': [
    "Bath time! Splish splash! That sounds lovely 🌟",
    "Baths are so relaxing! Enjoy the bubbles! ✨",
    "Bath time makes us all clean and cozy! 🌟"
  ],
  'a-board': [
    "Board games are so much fun! Who will you play with? 🌟",
    "I love board games! What's your favourite? ✨",
    "What a great idea! Board games bring everyone together 🌟"
  ],
  'a-sport': [
    "Sport is brilliant for your body and mind! 🌟",
    "Exercise makes us feel great! What sport do you like? ✨",
    "Sporty poodle! I love running around too! 🌟"
  ],
  'a-swim': [
    "Swimming is so much fun! Splash splash! 🌟",
    "I love swimming! Remember to always swim with a grown-up! ✨",
    "What a great activity! Swimming is wonderful! 🌟"
  ],
  'a-ride': [
    "Riding is such a great adventure! 🌟",
    "How exciting! Remember to stay safe! ✨",
    "What a fun thing to do! Enjoy the ride! 🌟"
  ],

  // ===== PLACES =====
  'pl-home': [
    "Home is where the heart is! You'll be there soon 💛",
    "I know you want to go home. It won't be long now 🌟",
    "Home is cozy and safe. You'll get there soon 💛"
  ],
  'pl-class': [
    "Learning time! Class is where the fun happens! 🌟",
    "Your classroom is waiting! Let's go learn! ✨",
    "Off to class! Today might be really fun! 🌟"
  ],
  'pl-playground': [
    "The playground is so much fun! Time to play! 🌟",
    "Playground time! What will you play on first? ✨",
    "I love the playground! Have lots of fun! 🌟"
  ],
  'pl-toilet': [
    "Tell a grown-up so they can help you go 💛",
    "That's important! Ask someone right away 🌟",
    "Tell your teacher or a grown-up nearby 💛"
  ],
  'pl-library': [
    "Libraries are magical places full of stories! 🌟",
    "I love the library! So many books to explore! ✨",
    "The library is wonderful! What will you read? 🌟"
  ],
  'pl-hall': [
    "The hall is a big space! What's happening there? 🌟",
    "Let's go to the hall! Something exciting might be happening! ✨",
    "Assembly time? Or something else fun? 🌟"
  ],
  'pl-office': [
    "The office has people who can help you. Go find them 💛",
    "Tell a grown-up you need to go to the office 🌟",
    "The office people are there to help! 💛"
  ],
  'pl-outside': [
    "Fresh air and sunshine await! 🌟",
    "Outside is wonderful! Let's go explore! ✨",
    "The outdoors is calling! What a great idea! 🌟"
  ],
  'pl-car': [
    "Ask a grown-up to take you to the car 💛",
    "Tell someone you need to go to the car 🌟",
    "A grown-up can help you get there safely 💛"
  ],
  'pl-shop': [
    "Shopping time! Remember to stay with a grown-up 🌟",
    "The shop has lots of things! Stay close to an adult ✨",
    "What do you need from the shop? 🌟"
  ],
  'pl-garden': [
    "The garden is beautiful! Flowers and fresh air! 🌟",
    "Gardens are magical places! Enjoy the nature! ✨",
    "What a lovely idea! The garden is so peaceful 🌟"
  ],

  // ===== SAFETY (CRITICAL - always redirect to trusted adults) =====
  's-hungry': [
    "You need to eat. Please tell a teacher or grown-up you trust right away 💛",
    "Not having food is really important. Tell an adult who can help you 💛",
    "You deserve to eat. Please find a grown-up and tell them 💛"
  ],
  's-wash': [
    "Tell a teacher or grown-up you trust. They can help you 💛",
    "You deserve to feel clean. Please tell an adult who can help 💛",
    "A teacher or grown-up can help you. Please tell them 💛"
  ],
  's-dirty': [
    "You deserve clean clothes. Please tell a teacher or grown-up 💛",
    "Tell a trusted adult and they will help you 💛",
    "A grown-up you trust can help you with this 💛"
  ],
  's-nosleep': [
    "Not sleeping is really hard. Please tell a teacher or grown-up you trust 💛",
    "You need sleep to be healthy. Tell an adult who cares about you 💛",
    "A grown-up should know about this. Please tell someone you trust 💛"
  ],
  's-nohelphurt': [
    "I'm really glad you told me. You are so brave. Please tell a teacher or grown-up you trust right away. You deserve to be looked after 💛",
    "That's not okay. You deserve help when you're hurt. Please tell a trusted adult — like a teacher, school nurse, or call Childline on 0800 1111 (free, 24/7) 💛",
    "You are very brave for sharing this. Please find a grown-up you trust and tell them what happened 💛"
  ],
  's-unsafe': [
    "I'm really glad you told me. You are so brave. Please tell a grown-up you trust right away — like a teacher, a parent, or you can call Childline on 0800 1111 (free, 24/7). You are not in trouble, and you deserve to be safe 💛",
    "Thank you for telling me. You are very brave. Please talk to a teacher, school nurse, or call Childline on 0800 1111 (free, 24/7). You deserve to feel safe 💛",
    "You deserve to be safe. Please tell a trusted adult — a teacher, family member, or call Childline on 0800 1111 (free, 24/7). You've done nothing wrong 💛"
  ],
  's-neglect': [
    "I'm really glad you told me. You deserve to be looked after. Please tell a teacher or trusted adult right away, or call Childline on 0800 1111 (free, 24/7) 💛",
    "You are so brave for telling me. Everyone deserves to be cared for. Please talk to a teacher or call Childline on 0800 1111 (free, 24/7) 💛",
    "That's not okay. You deserve love and care. Please tell a grown-up you trust, or call Childline on 0800 1111 (free, 24/7) 💛"
  ],
  's-secret': [
    "Some secrets are not okay to keep. Please tell a teacher or trusted adult. You will NOT get in trouble 💛",
    "Grown-ups should never ask you to keep secrets that make you feel bad. Please tell a teacher or call Childline on 0800 1111 (free, 24/7) 💛",
    "You are brave for telling me. Bad secrets should always be shared with a trusted adult. You're doing the right thing 💛"
  ],
  's-hurts': [
    "I'm really glad you told me. You are so brave. Please tell a grown-up you trust right away — like a teacher, or call 999 (UK) or 911 (US). You are not in trouble, and you deserve to be safe 💛",
    "This is very important. You are not in trouble. Please tell a teacher, parent you trust, or call Childline on 0800 1111 (free, 24/7) right now 💛",
    "You are so brave. Nobody should hurt you. Please tell a trusted adult immediately, or call 999 (UK) / 911 (US) 💛"
  ],
  's-nohome': [
    "I hear you. Please tell a teacher or grown-up you trust how you feel. You deserve to be safe 💛",
    "That's a really important feeling. Please talk to a trusted adult — a teacher, school nurse, or call Childline on 0800 1111 (free, 24/7) 💛",
    "You're very brave for saying this. Please tell someone you trust. You deserve to feel safe everywhere 💛"
  ],

  // ===== WEATHER =====
  'w-sunny': [
    "Sunny days are lovely! Don't forget sun cream! 🌟",
    "I love sunshine! Everything feels warm and happy! ✨",
    "What a beautiful sunny day! Perfect for playing outside! 🌟"
  ],
  'w-cloudy': [
    "Cloudy skies can be really pretty! Like fluffy poodle fur! 🌟",
    "The clouds are having a little rest today ✨",
    "Cloudy days are cozy days! 🌟"
  ],
  'w-rainy': [
    "Rain helps the flowers grow! Puddle jumping is fun too! 🌟",
    "Pitter patter rain! Remember your wellies! ✨",
    "I love the sound of rain. It's so calming! 🌟"
  ],
  'w-snowy': [
    "Snow! How magical! Wrap up warm! ✨",
    "Snowy days are like a winter wonderland! 🌟",
    "I love snow! Everything looks so pretty and white! ✨"
  ],
  'w-windy': [
    "Whoooosh! Hold on to your hat! 🌟",
    "Windy days are great for kite flying! ✨",
    "The wind is having a big day! Stay warm! 🌟"
  ],
  'w-stormy': [
    "Storms can be loud but you're safe inside 💛",
    "Stay inside where it's safe and cozy. Storms always pass 💛",
    "It's okay if storms feel scary. They always go away 💛"
  ],
  'w-hot': [
    "Stay cool! Drink lots of water on hot days! 🌟",
    "Hot days mean ice cream weather! Stay hydrated! ✨",
    "Remember to drink water and find some shade! 🌟"
  ],
  'w-cold': [
    "Brr! Wrap up warm with a cozy jumper! 🌟",
    "Cold days are perfect for hot chocolate! ✨",
    "Stay warm and cozy! Put on your warmest clothes! 🌟"
  ],
  'w-rainbow': [
    "A rainbow! How beautiful! Each colour is magical! 🌟",
    "Rainbows are nature's painting! So pretty! ✨",
    "Wow, a rainbow! That means the sun and rain are friends! 🌟"
  ],
  'w-foggy': [
    "Fog makes everything look mysterious and magical! 🌟",
    "Foggy days are like being inside a cloud! ✨",
    "Stay close to grown-ups on foggy days! 🌟"
  ],

  // ===== DAYS =====
  'd-mon': [
    "Monday! A brand new week of adventures! 🌟",
    "Happy Monday! What exciting things will happen this week? ✨",
    "Mondays are fresh starts! Let's make it a great one! 🌟"
  ],
  'd-tue': [
    "Tuesday! The week is getting going! 🌟",
    "Happy Tuesday! You're doing great this week! ✨",
    "Tuesdays are wonderful! What are you up to today? 🌟"
  ],
  'd-wed': [
    "Wednesday — we're halfway through the week! 🌟",
    "Happy Wednesday! You're doing brilliantly! ✨",
    "It's the middle of the week! Keep going! 🌟"
  ],
  'd-thu': [
    "Thursday! Nearly the weekend! 🌟",
    "Happy Thursday! One more sleep until Friday! ✨",
    "Thursdays are exciting — the weekend is close! 🌟"
  ],
  'd-fri': [
    "Friday! The weekend is almost here! 🌟",
    "TGIF! What fun things will you do this weekend? ✨",
    "Happy Friday! Time to celebrate the week! 🌟"
  ],
  'd-sat': [
    "Saturday! Weekend fun time! 🌟",
    "It's Saturday! Time for adventures! ✨",
    "Saturdays are for fun and playing! 🌟"
  ],
  'd-sun': [
    "Sunday! A lovely restful day! 🌟",
    "Happy Sunday! A great day to relax and play! ✨",
    "Sundays are so peaceful and lovely! 🌟"
  ],
  'd-today': [
    "What a great question! Check the calendar with a grown-up! 🌟",
    "Every day is a special day! Ask someone what day it is today! ✨",
    "Good thinking! A grown-up or calendar can tell you! 🌟"
  ],
  'd-tomorrow': [
    "Tomorrow is a new adventure! Exciting things are coming! 🌟",
    "I wonder what tomorrow will bring! Ask a grown-up! ✨",
    "Tomorrow will be wonderful! 🌟"
  ],
  'd-yesterday': [
    "Yesterday is already gone — what a memory! 🌟",
    "I hope yesterday was a good day! What did you do? ✨",
    "Ask a grown-up to help you remember yesterday! 🌟"
  ],
  'd-weekend': [
    "Weekends are the best! Time for fun and family! 🌟",
    "Yay, weekend! What are you going to do? ✨",
    "Weekend vibes! Enjoy every moment! 🌟"
  ],

  // ===== TIME =====
  'tm-morning': [
    "Good morning! A brand new day is starting! 🌟",
    "Morning time! The world is waking up! ✨",
    "Rise and shine! Today is going to be great! 🌟"
  ],
  'tm-afternoon': [
    "Good afternoon! The day is going well! 🌟",
    "Afternoon already! Time flies when you're having fun! ✨",
    "Hope your afternoon is lovely! 🌟"
  ],
  'tm-evening': [
    "Good evening! Time to wind down 🌟",
    "Evening time! What a day it's been! ✨",
    "The evening is cozy and peaceful 🌟"
  ],
  'tm-night': [
    "Night night! Sweet dreams! 💛",
    "Night time! Time for rest and lovely dreams 🌟",
    "Goodnight! Tomorrow is a new adventure! 💛"
  ],
  'tm-now': [
    "Great question! Check a clock nearby or ask a grown-up! 🌟",
    "Time is always ticking! Look at a clock to find out! ✨",
    "Ask someone near you — they'll know the time! 🌟"
  ],
  'tm-soon': [
    "Soon! Be patient — good things come to those who wait! 🌟",
    "Not long now! You're doing great at waiting! ✨",
    "It will be here before you know it! 🌟"
  ],
  'tm-wait': [
    "Waiting can be hard! Try counting to 10 slowly 💛",
    "I know waiting is tough. You're doing really well! 🌟",
    "Be patient — the wait will be worth it! 💛"
  ],
  'tm-late': [
    "Don't worry! Tell a grown-up and they can help 💛",
    "It's okay! Things happen. Ask for help if you need it 🌟",
    "Everyone is late sometimes. It's okay! 💛"
  ],
  'tm-early': [
    "Early mornings can be tough! Maybe rest a little more 💛",
    "Being up early means more time for fun later! 🌟",
    "Early bird! You're up before everyone else! 🌟"
  ],
  'tm-lunch': [
    "Mmm, lunchtime! Food is fuel for fun! 🌟",
    "I love lunchtime! What will you have? ✨",
    "Lunchtime is one of the best times! Yummy! 🌟"
  ],
  'tm-breakfast': [
    "Breakfast is the most important meal! Start the day strong! 🌟",
    "Time for breakfast! What's your favourite? ✨",
    "Breakfast gives you energy for the whole day! 🌟"
  ],
  'tm-dinner': [
    "Dinner time! A warm meal sounds lovely! 🌟",
    "Yummy, dinner! What are you having? ✨",
    "Dinner time is family time! Enjoy! 🌟"
  ],
  'tm-tea': [
    "Tea time! A lovely tradition! 🌟",
    "Time for tea and maybe a biscuit? ✨",
    "Tea time is so cozy! 🌟"
  ],
  'tm-playtime': [
    "Playtime is the BEST time! What will you play? 🌟",
    "Yay, playtime! Go have fun! ✨",
    "The best part of the day! Enjoy every minute! 🌟"
  ],
  'tm-hometime': [
    "Home time! Time to go back to your cozy house! 🌟",
    "Yay, home time! I bet you can't wait! ✨",
    "Nearly time to go home! How exciting! 🌟"
  ],

  // ===== MONTHS =====
  'm-jan': [
    "January! A brand new year full of possibilities! 🌟",
    "Happy January! Everything starts fresh this month! ✨",
    "January is cold but full of new beginnings! 🌟"
  ],
  'm-feb': [
    "February! The month of love and kindness! 🌟",
    "Happy February! Spread love everywhere you go! ✨",
    "February is short but sweet! 🌟"
  ],
  'm-mar': [
    "March! Spring is on its way! Flowers are starting to bloom! 🌟",
    "Happy March! The world is waking up from winter! ✨",
    "March brings spring! How exciting! 🌟"
  ],
  'm-apr': [
    "April! Spring showers and beautiful flowers! 🌟",
    "Happy April! Everything is blooming! ✨",
    "April is so colourful and pretty! 🌟"
  ],
  'm-may': [
    "May! The world is full of colour! 🌟",
    "Happy May! Such a beautiful month! ✨",
    "May means longer days and more sunshine! 🌟"
  ],
  'm-jun': [
    "June! Summer is nearly here! 🌟",
    "Happy June! Sunshine and warm days! ✨",
    "June is wonderful! Nearly summer holidays! 🌟"
  ],
  'm-jul': [
    "July! Summer holidays and sunshine! 🌟",
    "Happy July! Time for summer adventures! ✨",
    "July is beach and ice cream month! 🌟"
  ],
  'm-aug': [
    "August! The summer is in full swing! 🌟",
    "Happy August! Enjoy every sunny moment! ✨",
    "August adventures are the best! 🌟"
  ],
  'm-sep': [
    "September! A new school year begins! 🌟",
    "Happy September! Autumn leaves are on their way! ✨",
    "September means new beginnings! 🌟"
  ],
  'm-oct': [
    "October! Autumn colours and cozy evenings! 🌟",
    "Happy October! Leaves are turning golden! ✨",
    "October is magical with all its colours! 🌟"
  ],
  'm-nov': [
    "November! Getting closer to the festive season! 🌟",
    "Happy November! Wrap up warm and stay cozy! ✨",
    "November nights are perfect for stories! 🌟"
  ],
  'm-dec': [
    "December! The most magical month of all! 🌟",
    "Happy December! Sparkles and joy everywhere! ✨",
    "December is full of wonder and excitement! 🌟"
  ],
  'm-spring': [
    "Spring is when everything comes alive! Flowers and baby animals! 🌟",
    "I love spring! The world is so colourful! ✨",
    "Spring means new beginnings and warm breezes! 🌟"
  ],
  'm-summer': [
    "Summer is amazing! Sunshine, ice cream, and long days! 🌟",
    "I love summer! So many fun things to do! ✨",
    "Summer days are the best days! 🌟"
  ],
  'm-autumn': [
    "Autumn is so beautiful! Golden leaves everywhere! 🌟",
    "I love autumn! Crunchy leaves and cozy jumpers! ✨",
    "Autumn colours are like nature's painting! 🌟"
  ],
  'm-winter': [
    "Winter is cozy and magical! Wrap up warm! 🌟",
    "I love winter! Hot chocolate and warm blankets! ✨",
    "Winter brings snow and sparkles! 🌟"
  ],
};

// Fallback responses for emotion buttons and quick cards (by emotion/id)
const EMOTION_RESPONSES = {
  'happy': [
    "That makes me so happy too! Your smile is like sunshine! 💛",
    "Yay! I love when you feel happy! 🌟",
    "Happy is the best feeling! I'm wagging my tail! ✨"
  ],
  'sad': [
    "I'm sorry you feel sad. I'm right here with you 💛",
    "It's okay to feel sad. Would you like a gentle hug? 💛",
    "Sad feelings are hard. You're brave for telling me 🌟"
  ],
  'nervous': [
    "It's okay to feel nervous. Take a deep breath with me 💛",
    "Being nervous just means you care! You've got this! 🌟",
    "Nervousness is normal. I believe in you! 💛"
  ],
  'angry': [
    "It's okay to feel angry. Let's take a deep breath together 💛",
    "Anger is a big feeling. You're doing well by telling me 🌟",
    "Being angry is okay. Breathe in slowly, breathe out slowly 💛"
  ],
  'calm': [
    "Feeling calm is so lovely! I feel calm with you too 💛",
    "What a peaceful feeling! I love that for you 🌟",
    "Calm and peaceful — that's really wonderful ✨"
  ],
  'learning': [
    "I love learning! What shall we explore together? 🌟",
    "Learning is an adventure! You're so curious! ✨",
    "Yay, learning time! What would you like to know? 🌟"
  ],
  'stressed': [
    "I hear you. Stress is really tough. Take a deep breath 💛",
    "Being stressed is hard. Remember to be kind to yourself 🌟",
    "You're dealing with a lot. It's okay to slow down 💛"
  ],
  'anxious': [
    "Anxiety is really hard. You're not alone in this 💛",
    "Those anxious feelings are tough. Try some slow breathing 🌟",
    "I'm here with you. Anxiety doesn't define you 💛"
  ],
  'lonely': [
    "Feeling lonely is really hard. But you're not alone — I'm here 💛",
    "Loneliness is tough. Remember, people care about you 🌟",
    "I'm right here with you. You matter so much 💛"
  ],
  'confused': [
    "That's okay! Everyone feels confused sometimes 💛",
    "Being confused just means you're thinking hard! 🌟",
    "I get confused too! It's totally normal 💛"
  ],
  'okay': [
    "Just okay is perfectly fine! Not every day needs to be amazing 💛",
    "That's totally valid. Sometimes okay is enough 🌟",
    "Okay is a good place to be. I'm glad you're here 💛"
  ],
};

// Quick message responses (AAC cards and teen quick messages)
const QUICK_MSG_RESPONSES = {
  'want': [
    "What would you like? You can tell me or show a grown-up 💛",
    "I'm listening! What do you want? 🌟",
    "Tell me what you'd like and I'll try to help! 💛"
  ],
  'help': [
    "I'm here to help! What do you need? 💛",
    "Asking for help is really brave! What can I do? 🌟",
    "I'll do my best to help! Tell me more 💛"
  ],
  'tired': [
    "Being tired is really normal. Rest when you can 💛",
    "Your body is telling you it needs rest. Listen to it! 🌟",
    "Sleepy time! It's okay to take a break 💛"
  ],
  'confused': [
    "That's okay! Not understanding is totally normal 💛",
    "Confusion means you're thinking! Ask someone to explain 🌟",
    "I get confused too! It's okay to ask for help 💛"
  ],
  'lonely': [
    "You're not alone — I'm right here with you 💛",
    "Feeling lonely is hard. But people care about you 🌟",
    "I'm here and I'm glad you told me 💛"
  ],
  'scared': [
    "Being scared is okay. I'm here with you 💛",
    "You're so brave for telling me. You're safe right now 🌟",
    "It's okay to feel scared. Take a deep breath 💛"
  ],
  'vent': [
    "I'm here — let it all out. No judgment 💛",
    "Sometimes you just need to get things off your chest. Go for it 🌟",
    "Venting is healthy! I'm listening 💛"
  ],
  'pressure': [
    "That sounds really overwhelming. You don't have to be perfect 💛",
    "Pressure from others is exhausting. Remember, you're enough as you are 🌟",
    "It's okay to set boundaries. Your wellbeing matters most 💛"
  ],
  'leftout': [
    "Feeling left out really hurts. Your feelings are completely valid 💛",
    "That's a tough feeling. You deserve to be included 🌟",
    "Being left out stings. But it says nothing about your worth 💛"
  ],
  'school': [
    "School stress is so real. Remember to take breaks 💛",
    "It's okay to feel stressed about school. You're doing your best 🌟",
    "School can be overwhelming. Be kind to yourself 💛"
  ],
  'family': [
    "Home stuff can be really hard. Your feelings about it are valid 💛",
    "Family situations are tough sometimes. Remember it's not your fault 🌟",
    "I hear you. If things feel really hard, a school counselor can help too 💛"
  ],
  'myself': [
    "You are more amazing than you know. Really 💛",
    "Self-doubt is something everyone experiences. But you are enough 🌟",
    "I see someone brave just by you being here. You matter 💛"
  ],
  // Tiny-mode (3-5) — single sentence, simple words, lots of warmth
  'hug': [
    "Big squishy hug for you! 🤗",
    "Aww, here's a hug! 💛",
    "Squeeze! You are so loved 🤗"
  ],
  'done': [
    "Yay! All done! 🌟",
    "Well done you! ✨",
    "Hooray! 🎉"
  ],
  'more': [
    "Yay, more fun! 🌟",
    "Okay, here we go again! ✨",
    "More? Yes please! 💛"
  ],
  'hungry': [
    "Yum! Time for a snack 🍎",
    "Tummy says food! Ask a grown-up 💛",
    "Snack time! 🌟"
  ],
  'thirsty': [
    "Glug glug! Time for a drink 🥛",
    "A nice cool drink will help 💛",
    "Sippy time! 🌟"
  ],
  'sleepy': [
    "Soft and cosy time 😴",
    "Rest is lovely. Snuggle up 💛",
    "Sleepy bye-bye soon 🌙"
  ],
  'happy': [
    "Yay! I'm happy too! 🌟",
    "Happy dance! 💛",
    "Wow, lovely! ✨"
  ],
  'sad': [
    "Aww, big hug for you 🤗",
    "It's okay to be sad. I'm here 💛",
    "Squeeze! You're not alone 💛"
  ],
  'play': [
    "Yay! Let's play! 🧸",
    "Playtime! What shall we do? 🌟",
    "I love playing too! 💛"
  ],
  'potty': [
    "Tell a grown-up — they'll help! 🌟",
    "Off to the potty! 💛",
    "Good telling! Find your grown-up 💛"
  ],
  'mum': [
    "Aww, find Mummy for a big cuddle 💛",
    "Mummy is special. Go give her a hug 🤗",
    "I bet Mummy loves you SO much 💛"
  ],
  // Sentence Builder (AAC) — kid taps cards to build a sentence. Without an
  // LLM call (free feature), we send a warm, open acknowledgement that works
  // for any constructed sentence — same gentle tone as the rest of the app.
  sentence_builder: [
    "Thank you for telling me that! I heard every word 💛",
    "Wow, you put that together so well ✨ I'm listening with my whole heart.",
    "I hear you, friend. That's really clear 💛",
    "Thank you for using your words with me — that took bravery! 🌟",
    "I love how you built that sentence! Tell me more when you're ready 💛",
    "Beautiful sentence ✨ I'm here, paying full attention.",
  ],
};

export const getCardResponse = (cardId) => {
  const responses = CARD_RESPONSES[cardId];
  if (responses && responses.length > 0) {
    return responses[Math.floor(Math.random() * responses.length)];
  }
  return "That's really interesting! Thank you for sharing with me 💛";
};

export const getEmotionResponse = (emotionKey) => {
  const responses = EMOTION_RESPONSES[emotionKey];
  if (responses && responses.length > 0) {
    return responses[Math.floor(Math.random() * responses.length)];
  }
  return "Thank you for telling me how you feel. I'm here for you 💛";
};

export const getQuickMsgResponse = (msgId) => {
  const responses = QUICK_MSG_RESPONSES[msgId];
  if (responses && responses.length > 0) {
    return responses[Math.floor(Math.random() * responses.length)];
  }
  return "Thank you for sharing that with me 💛";
};
